import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { USER_ROLES } from '../../constants/userRoles';

function PacienteRoute({ children }) {
    const { user } = useAuth();

    if (user?.rol !== USER_ROLES.PACIENTE) {
        return <Navigate to="/" replace />;
    }

    return children;
}

export default PacienteRoute;
